export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  stickyHeaders: false,
  customRowKey: 'uid',
  toolBar: false,
  fields: [
    {
      name: 'field-generic-input',
      width: '25%',
      title: 'Delivery',
      prop: 'name',
      id: 'name',
      isItemDelivery: true,
      searchable: true,
    },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'QTY Shipped',
      prop: 'total',
      id: '',
      searchable: true,
    },
    // {
    //   name: 'field-generic-input',
    //   width: '10%',
    //   title: 'QTY Short (Load)',
    //   prop: '',
    //   id: '',
    //   isItemDelivery: true,
    // },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'QTY Received',
      prop: 'delivered',
      id: '',
      isItemDelivery: true,
    },
    // {
    //   name: 'field-generic-input',
    //   width: '10%',
    //   title: 'QTY Short (Receive)',
    //   prop: '',
    //   id: '',
    //   isItemDelivery: true,
    // },
    {
      name: 'qtyShort',
      title: 'QTY Short',
      width: '10%',
    },
    {
      name: 'itemDeliveries',
      width: '10%',
      title: 'Delivery Status / Receipt Method',
      id: 'itemDeliveries',
      defaultVisible: true,
    },
    // {
    //   name: 'field-generic-input',
    //   width: '25%',
    //   title: 'Reported Issue (if applicable)',
    //   prop: '',
    //   id: '',
    //   isItemDelivery: true,
    // },
  ],
};
